import { createSelector } from '@reduxjs/toolkit';
import { REVIEWS_PATH_SUFFIX } from '../../routes/Hotel/constants/reviews';

import {
  getFromImmutableStateCompatible,
  getImmutableCompatible,
} from '../../utils/immutableUtils';
import { getHotelLink } from '../../routes/Hotel/store/selectors/hotel';
import type { ReviewStore } from './types';

const _getReviewsState = (state) => getImmutableCompatible(state, 'reviews');
export const getReviewsState =
  getFromImmutableStateCompatible<ReviewStore>(_getReviewsState);
export const getReviewsFetching = createSelector(
  getReviewsState,
  (reviews) => reviews.fetching,
);

export const getReviewsVisible = createSelector(
  getReviewsState,
  (reviews) => reviews.visibleCount,
);
export const getReviewsLTRaw = createSelector(
  getReviewsState,
  (reviews) => reviews.data,
);
export const getReviewsLT = createSelector(getReviewsLTRaw, (items) =>
  items
    ? items.map((item) => {
        // старые компоненты используют старые поля
        if (item.avatar_url && item.name) {
          return {
            ...item,
            author_image: item.avatar_url,
            initials: item.name,
            phrase: item.title,
          };
        }
        return item;
      })
    : [],
);
export const getReviewsLTVisible = createSelector(
  [getReviewsLT, getReviewsVisible],
  (items, visible) => items.slice(0, visible),
);
export const getReviewsLTVisibleRaw = createSelector(
  [getReviewsLTRaw, getReviewsVisible],
  (items, visible) => items?.slice(0, visible),
);
export const getReviewsLTShowMoreVisible = createSelector(
  [getReviewsLT, getReviewsVisible],
  (items, visible) => items.length > visible,
);

export const getLastReview = createSelector(
  getReviewsLT,
  (items) => items.length > 0 && items[0],
);

export const isLastReview = createSelector([getLastReview], (lastReview) =>
  Boolean(lastReview),
);

export const getReviewsCount = createSelector(
  getReviewsLT,
  (reviews) => reviews.length,
);

/**
 * Возвращает ссылку на отельные отзывы
 * @param {object} state reducer
 * @returns hotel public_url(stirng) + '/reviews'
 */
export const getHotelReviewsLink = (state) =>
  `${getHotelLink(state)}${REVIEWS_PATH_SUFFIX}`;
